import { AppRouter } from 'router/AppRouter';
import GlobalStyle from 'styles/GlobalStyle';
import GetFrontendConfig from 'hooks/getFrontConfig';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { App as AntdApp, ConfigProvider } from 'antd';
import locale from 'antd/locale/es_ES';
import { useThemeWatcher } from 'hooks/useThemeWatcher';
import { getAntDesignTheme } from 'styles/themes/antDesignTheme';

function App() {
  const frontendConfig = GetFrontendConfig();
  const resolvedTheme = useThemeWatcher();

  return (
    <>
      {frontendConfig && (
        <GoogleOAuthProvider clientId={frontendConfig.google.authClientId}>
          <GlobalStyle />
          <div className="App" data-antd-theme={resolvedTheme}>
            <ConfigProvider
              locale={locale}
              theme={getAntDesignTheme(resolvedTheme)}
            >
              <AntdApp>
                <AppRouter />
              </AntdApp>
            </ConfigProvider>
          </div>
        </GoogleOAuthProvider>
      )}
    </>
  );
}

export default App;
